import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ProfileProvider } from "@/context/ProfileContext";
import { AuthCallback } from "@/components/AuthCallback";
import Login from "@/pages/SignIn";
import Day from "@/pages/DayTimeline";
import Compliance from "@/pages/ComplianceGrid";
import Insights from "@/pages/Insights";
import MedicineList from "@/pages/Meds";
import Settings from "@/pages/SettingsPage";
import MedicineCalendar from "@/pages/MedicineCalendar";
import ResetPassword from "@/pages/ResetPassword";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#0B1120]" data-testid="auth-loading" />;
  if (!user) return <Navigate to="/" replace />;
  return <ProfileProvider>{children}</ProfileProvider>;
};

const AppRouter = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/day" element={<Protected><Day /></Protected>} />
      <Route path="/dashboard" element={<Navigate to="/day" replace />} />
      <Route path="/compliance" element={<Protected><Compliance /></Protected>} />
      <Route path="/compliance/:medId" element={<Protected><MedicineCalendar /></Protected>} />
      <Route path="/insights" element={<Protected><Insights /></Protected>} />
      <Route path="/medicines" element={<Protected><MedicineList /></Protected>} />
      <Route path="/settings" element={<Protected><Settings /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

const Landing = () => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#0B1120]" data-testid="auth-loading" />;
  if (user) return <Navigate to="/day" replace />;
  return <Login />;
};

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster
          position="bottom-center"
          theme="dark"
          toastOptions={{
            style: {
              background: "rgba(2,6,23,0.9)",
              border: "1px solid rgba(56,189,248,0.3)",
              color: "#F8FAFC",
              boxShadow: "0 0 24px rgba(56,189,248,0.18)",
            },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}
